import Helper from "./Helper";

class Lottie {
  constructor() {

    this.lotties = document.querySelectorAll('lottie-player');
    this.lottiesArray = Array.prototype.slice.call(this.lotties);
    this.classIn = 'is-in-viewport';
    this.classOut = 'is-not-in-viewport';

    if (this.lotties && this.lotties.length !== 0) {
      this.registerScroll();
      this.bindEvents();
    }
  }

  bindEvents() {
    this.lottiesArray.forEach((item) => {
      if (Helper.isInViewport(item)) {
        Helper.addClass(item, this.classIn);
        Helper.removeClass(item, this.classOut);
      } else {
        Helper.removeClass(item, this.classIn);
        Helper.addClass(item, this.classOut);
      }
    });
  }

  registerScroll() {
    window.addEventListener("scroll", (e) => {
      this.lottiesArray.forEach((item, index) => {
        this.addClassOnScroll(item);
        if (Helper.hasClass(item, this.classIn)) {
          item.play();
        }
      });
    });
  }

  addClassOnScroll(element) {
    if(element.closest('.lc-start-keyfigures__item-inner')) {
      if(Helper.isInViewport(element.closest('.lc-start-keyfigures__item-inner').querySelector('.lc-start-keyfigures__content'))) {
        Helper.addClass(element, this.classIn);
        Helper.removeClass(element, this.classOut);
      }
    } else if (Helper.isInViewport(element)) {
      Helper.addClass(element, this.classIn);
      Helper.removeClass(element, this.classOut);
    } else {
      Helper.addClass(element, this.classOut);
      Helper.removeClass(element, this.classIn);
    }
  }

}

export default Lottie;
